<!--报文异常监控-->
<template>
    <div>
        <Panel title="报文异常查询">
            <template slot="buttons">
                <el-button title="查询" class="blue" @click="pageTable.handleLoad()" icon="el-icon-fa-search">查询</el-button>
                <el-button title="重置" class="yellow" @click="pageTable.handleReset()" icon="el-icon-fa-undo">重置</el-button>
            </template>
            <el-form ref="queryForm">
                <el-row>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item label="报文编号">
                            <el-input v-model="pageTable.param.ms_uid"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item label="线程名称">
                            <el-input v-model="pageTable.param.td_name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg='8' :sm='12'>
                        <el-form-item class="flex-2" label="异常时间">
                            <el-date-picker v-model="pageTable.param.range_time" type="datetimerange" placeholder="选择日期范围"
                                            :picker-options="UsualConfig.pickerOptionsQuickSelect"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </Panel>
        <Panel title="报文异常列表">
            <template slot="buttons">
                <el-button title="删除选定" class="red" @click="doSeleDel" icon="el-icon-fa-trash">删除选定</el-button>
                <el-button title="删除全部" class="red" @click="doAllDel" icon="el-icon-fa-trash">删除全部</el-button>
            </template>
            <el-table highlight-current-row stripe border :data="pageTable.data" v-loading="pageTable.isLoading"
                      ref="table" @selection-change="handleSelectionChange" element-loading-spinner="el-icon-loading"
                      element-loading-text="数据加载中" :height="tableHeight" @sort-change="handleSorted">
                <el-table-column prop="$rownum" label="NO." width="70" align="center"/>
                <el-table-column type="selection" align='center' width='50'></el-table-column>
                <el-table-column prop="msuid" label="报文编号" sortable="custom" show-overflow-tooltip></el-table-column>
                <el-table-column prop="tdname" label="线程名称" sortable="custom" show-overflow-tooltip></el-table-column>
                <el-table-column prop="pedesc" label="异常信息" show-overflow-tooltip></el-table-column>
                <el-table-column prop="retime" label="异常时间" :formatter="formatterDateTime" sortable="custom" width="150"></el-table-column>
                <el-table-column prop="pecode" label="异常代码" sortable="custom" width='80px' show-overflow-tooltip></el-table-column>
                <!--<el-table-column prop="host" label="主机标识" sortable="custom" show-overflow-tooltip></el-table-column>-->
                <el-table-column label="操作" width="160px" align="center">
                    <template slot-scope="scope">
                        <el-button title="报文信息" class="blue" icon="el-icon-document" @click="doMsEdit(scope.row.uuid)">报文信息</el-button>
                        <el-button title="查看堆栈" class="red" icon="el-icon-cpu" @click="getPestack(scope.row.pestack)">查看堆栈</el-button>
                    </template>
                </el-table-column>
            </el-table>

<!--            <export-ctrl class="pull-left" @export="pageTable.handleExport($event, $refs.table)"/>-->
            <el-pagination background :page-size.sync="pageTable.size" :current-page.sync="pageTable.curr"
                           :total="pageTable.total"/>
        </Panel>

        <el-dialog close-on-press-escape append-to-body v-draggable title="异常堆栈内容" :visible.sync="dialogVisible" width="60%" :modal="false">
            <el-input type="textarea" :rows="20" placeholder="堆栈内容" v-model="textarea">
            </el-input>
        </el-dialog>

        <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="editorms.show" title="报文信息"
                   width="800px" height="400px">
            <div v-if="editorms.show">
                <MsEdit v-if="editorms.show" ref="edit" :datms='msdata' :formatshow=false :uuid='msuuid'></MsEdit>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ErrorApi from "./Error";
    import MsEdit from "./persistent/MsInfo";
    import {PageTable, UsualConfig} from 'cnetong-core-frontend';

    export default {
        name: "Error",
        components: {MsEdit},
        props: {
            pageSize: {type: Number},
            tableHeight: {type: String, default: 'calc(100vh - 281px)'}
        },
        data() {
            return {
                UsualConfig,
                pageTable: new PageTable({
                    autoLoad: true,
                    doLoad: ErrorApi.errorlist,
                    size: this.pageSize,
                    param: {
                        range_time: [new Date(new Date(new Date().setHours(0)).setMinutes(0)).setSeconds(0),
                            new Date(new Date(new Date().setHours(23)).setMinutes(59)).setSeconds(59)],
                        orderField: "re_time",
                        orderDirection: 'desc'
                    }
                }),
                multipleSelection: [],
                all: [],
                dialogVisible: false,
                textarea: "",
                editor: {
                    show: false,
                    loading: false
                },
                editorms: {
                    show: false,
                    loading: false,
                    uuid: ""
                },
                msdata: {}
            };
        },
        methods: {
            handleSorted({column, prop, order}) {
                if (!order) {
                    this.pageTable.param.orderDirection = 'desc';
                    this.pageTable.param.orderField = 're_time';
                    this.queryError();
                    return;
                } else if (order === "ascending") {
                    this.pageTable.param.orderDirection = "asc";
                } else if (order === "descending") {
                    this.pageTable.param.orderDirection = "desc";
                }

                if (prop === "retime") {
                    this.pageTable.param.orderField = "re_time";
                } else if (prop === "pestack") {
                    this.pageTable.param.orderField = "pe_stack";
                } else if (prop === "pecode") {
                    this.pageTable.param.orderField = "pe_code";
                } else if (prop === "tdname") {
                    this.pageTable.param.orderField = "td_name";
                } else if (prop === "msuid") {
                    this.pageTable.param.orderField = "ms_uid";
                }

                this.queryError();
            },
            getPestack(value) {
                this.dialogVisible = true;
                this.textarea = value;
            },
            async doAllDel() {
                await this.confirm();
                await ErrorApi.delAllError(this.all);
                await this.queryError();
            },
            // 删除选定
            async doSeleDel() {
                if (this.multipleSelection.length === 0) {
                    this.$message.warning("请选择数据！");
                    return;
                }
                try {
                    await this.confirm();
                    this.pageTable.isLoading = true;
                    let array = this.multipleSelection.map(v => v.uuid);
                    await ErrorApi.delError(array);
                    this.queryError();
                } finally {
                    this.pageTable.isLoading = false;
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 查询
            queryError() {
                this.pageTable.handleLoad();
            },
            //报文信息
            async doMsEdit(uuid) {
                await this.getMsMould(uuid);
            },
            getMsMould(uuid) {
                this.msuuid = uuid;
                ErrorApi.getErrorMessage(uuid).then(resp=>{
                  this.msdata = resp;
                  this.openmsDialog();
                });
            },
            openmsDialog() {
                this.loading = true;
                this.editorms.show = true;
                this.loading = false;
            }
        }
    };
</script>

<style>
    .el-tooltip__popper {
        max-width: 400px;
        line-height: 180%;
    }
</style>